module.exports = __webpack_public_path__ + "static/media/own-goal.svg.7dcacb3c.png";